import { latestArticles } from "@/mocks/articles";
import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";

export default function LatestArticles() {
  const main = latestArticles[0];
  const list = latestArticles.slice(1, 4);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        kicker="最新发布"
        title="最新资讯抢先看"
        desc="新游漫画化、版本更新漫画与活动漫画，最新情报持续更新。"
        to="/banben-gengxin"
        linkText="进入版本更新"
      />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-5">
        <div className="lg:col-span-3">
          <ArticleCard article={main} />
        </div>
        <div className="flex flex-col gap-4 lg:col-span-2">
          {list.map((a) => (
            <ArticleCard key={a.slug} article={a} horizontal />
          ))}
        </div>
      </div>
    </section>
  );
}